// extracted by mini-css-extract-plugin
export default {"fAQList":"FAQList_fAQList__1DUoy","fAQItem":"FAQList_fAQItem__0ywfC"};